import classnames from 'classnames';
import { Satisfaction } from 'lib-shared-legacy-types';
import { PureComponent } from 'react';

import { ScoreIcon } from 'fable/ScoreIcon';

import style from './index.module.scss';

type Props = {
  thankYouText: string;
  questionText: string;
  placeholderText: string;
  submitButtonText: string;
  ratingStyle: Satisfaction.RatingStyle;
};

type State = {
  dir: string;
};

const defaultRatingStyle: Satisfaction.RatingStyle = 'emojis';

const getTextDir = (text: string) => {
  const elem = document.createElement('p');
  elem.setAttribute('hidden', 'true');
  elem.setAttribute('dir', 'auto');
  elem.innerText = text;
  document.body.append(elem);
  const dir = window.getComputedStyle(elem).direction;
  elem.remove();

  return dir;
};

export class LandingCsatPreview extends PureComponent<Props, State> {
  state = {
    dir: 'ltr',
  };

  componentDidMount() {
    this.setTextDir();
  }

  componentDidUpdate(prevProps: Props) {
    const { placeholderText } = this.props;

    if (placeholderText !== prevProps.placeholderText) {
      this.setTextDir();
    }
  }

  setTextDir() {
    const { placeholderText } = this.props;

    if (placeholderText) {
      this.setState({
        dir: getTextDir(placeholderText),
      });
    }
  }

  render() {
    const {
      thankYouText,
      questionText,
      placeholderText,
      submitButtonText,
      ratingStyle = defaultRatingStyle,
    } = this.props;
    const { dir } = this.state;

    return (
      <div className={style.backdrop}>
        <section className={style.feedbackWrapper}>
          <ScoreIcon style={ratingStyle} score={4} size={40} showAll />
          <div className={style.thankYouText} dir="auto">
            {thankYouText}
          </div>
          <div className={style.question} dir="auto">
            {questionText}
          </div>
          <textarea
            className={classnames(style.commentForm, style[dir])}
            placeholder={placeholderText}
            readOnly={true}
            dir="auto"
          />
          <input
            className={style.submitButton}
            value={submitButtonText}
            type="button"
            dir="auto"
          />
        </section>
      </div>
    );
  }
}
